import React, { useEffect } from "react";
import { Stack, StackProps } from "@bookingcom/bui-react";
import { type UnifiedPriceTagControllerProps } from "./useUnifiedPriceTag.controller";
import { UnifiedPriceTagPriceBreakdown } from "./UnifiedPriceTagPriceBreakdown";
import { UnifiedPriceTagPricePerAdultExplanation } from "./UnifiedPriceTagPricePerAdultExplanation";
import { UnifiedPriceTagExplanation } from "./UnifiedPriceTagExplanation";
import useUserAgent from "../../../hooks/useUserAgent";
import usePriceConsistencyMonitoringEvents from "../../../hooks/c360/usePriceConsistencyMonitoringEvents";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
import { UnifiedPriceTagMobile } from "./UnifiedPriceTag.mobile";
import { UnifiedPriceTagDesktop } from "./UnifiedPriceTag.desktop";

export type UnifiedPriceTagProps = UnifiedPriceTagControllerProps & Pick<StackProps, "attributes">;

export const UnifiedPriceTag = (props: UnifiedPriceTagProps) => {
  const { productId, price, priceAlignment, shouldShowPriceExplanationOnly, attachedAncillaries = [] } = props;
  const { isMobile } = useUserAgent();

  const trackPriceConsistencyMonitoringEvents = usePriceConsistencyMonitoringEvents();
  useEffect(() => {
    if (isFeatureRunningClientSide("FLIGHTS_PRICING_ENABLE_SUBMIT_C360_EVENTS_FOR_PRICE_CONSISTENCY") && productId) {
      trackPriceConsistencyMonitoringEvents("TAG", productId, [], price, attachedAncillaries);
    }
  }, [price, productId, trackPriceConsistencyMonitoringEvents, attachedAncillaries]);

  if (shouldShowPriceExplanationOnly) {
    return (
      <Stack direction="column" gap={0} attributes={{ "data-testid": "upt_container" }}>
        <Stack direction="row" justifyContent={priceAlignment}>
          <UnifiedPriceTagPricePerAdultExplanation {...props} />
          <UnifiedPriceTagPriceBreakdown {...props} />
        </Stack>
        <UnifiedPriceTagExplanation {...props} />
      </Stack>
    );
  }

  return isMobile ? <UnifiedPriceTagMobile {...props} /> : <UnifiedPriceTagDesktop {...props} />;
};
